<template>
    <v-row no-gutters class="mb-6">
        <v-col cols="12">
            <v-card class="team-section-card pa-4 pa-md-6">
                <div class="team-section-header">
                    <span class="team-section-kicker">Βαθμολογια</span>
                    <h2 class="team-section-title">Βαθμολογια Ομαδας</h2>
                </div>
                <div class="team-table-wrap">
                    <v-simple-table class="team-table">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>Θεση</th>
                                    <th>Ομαδα</th>
                                    <th v-for="column in standingsStatColumns" :key="column.key">{{ column.label }}</th>
                                    <th>Form</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in standings" :key="row.position" :class="{ 'floisvos-row': isFloisvosTeam(row.team) }">
                                    <td>{{ row.position }}</td>
                                    <td>
                                        <div class="team-cell-wrap">
                                            <img v-if="row.teamLogo" :src="row.teamLogo" :alt="`Έμβλημα ${row.team}`" class="team-logo">
                                            <span>{{ row.team }}</span>
                                        </div>
                                    </td>
                                    <td v-for="column in standingsStatColumns" :key="`${row.position}-${column.key}`">
                                        {{ row.statsValues[column.key] }}
                                    </td>
                                    <td>
                                        <div class="form-wrap">
                                            <span
                                                v-for="(token, tokenIndex) in row.formTokens"
                                                :key="`${row.position}-form-${tokenIndex}`"
                                                class="form-token"
                                                :class="getFormTokenClass(token)"
                                            >
                                                {{ token }}
                                            </span>
                                            <span v-if="!row.formTokens.length">-</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'TeamStandingsSection',
        props: {
            standings: {
                type: Array,
                default: () => []
            },
            standingsStatColumns: {
                type: Array,
                default: () => []
            },
            isFloisvosTeam: {
                type: Function,
                default: () => false
            },
            getFormTokenClass: {
                type: Function,
                default: () => ''
            }
        }
    }
</script>

<style scoped>
.team-section-card {
    background: rgba(255, 255, 255, 0.96);
}

.team-section-header {
    margin-bottom: 20px;
    text-align: left;
}

.team-section-kicker {
    display: inline-block;
    margin-bottom: 6px;
    color: #ac2f37;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.team-section-title {
    margin: 0;
    color: #223152;
    font-size: clamp(1.5rem, 2.4vw, 2.2rem);
    line-height: 1.15;
    text-transform: none !important;
}

.team-table-wrap {
    overflow-x: auto;
}

.team-table {
    min-width: 640px;
}

.team-cell-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}

.team-logo {
    width: 26px;
    height: 26px;
    object-fit: contain;
    flex: 0 0 26px;
}

.floisvos-row {
    background: #e6f4ff;
}

.form-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 26px;
}

.form-token {
    width: 24px;
    height: 24px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
}

.form-token-win {
    background: #e8f5e9;
    color: #1b5e20;
}

.form-token-loss {
    background: #ffebee;
    color: #b71c1c;
}

.form-token-neutral {
    background: #eceff1;
    color: #37474f;
}
</style>
